import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=180ece52&scoped=true&lang=pug&"
import script from "./Navbar.vue?vue&type=script&lang=js&"
export * from "./Navbar.vue?vue&type=script&lang=js&"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=180ece52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ece52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('180ece52')) {
      api.createRecord('180ece52', component.options)
    } else {
      api.reload('180ece52', component.options)
    }
    module.hot.accept("./Navbar.vue?vue&type=template&id=180ece52&scoped=true&lang=pug&", function () {
      api.rerender('180ece52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/navigation/Navbar.vue"
export default component.exports